import { createSlice } from "@reduxjs/toolkit"

export const pilotTrackingSliceName = "pilot-tracking"

const initialPilotTrackingState = {
    selected: {
        aircraftIds: {} as Record<string, boolean>,
    },
}

const slice = createSlice({
    name: pilotTrackingSliceName,
    initialState: initialPilotTrackingState,
    reducers: {
        toggleAircraftSelected: (state, { payload }: { payload: string }) => {
            state.selected.aircraftIds[payload]
                ? delete state.selected.aircraftIds[payload]
                : (state.selected.aircraftIds[payload] = true)
        },
        clearSelectedAircraftIds: (state) => {
            state.selected.aircraftIds = {}
        },
        setAircraftSelected: (
            state,
            { payload }: { payload: { id: string; selected: boolean } }
        ) => {
            payload.selected
                ? (state.selected.aircraftIds[payload.id] = payload.selected)
                : delete state.selected.aircraftIds[payload.id]
        },
    },
})

export const { toggleAircraftSelected, clearSelectedAircraftIds, setAircraftSelected } =
    slice.actions
export const PilotTrackingReducer = { [pilotTrackingSliceName]: slice.reducer }
